import styled from 'react-emotion';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

export const PostNavigationMenu = styled.div`
  font-family: ${theme.font.family.workSans};
  font-style: normal;
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.small};

  text-align: right;
  cursor: pointer;

  color: ${theme.color.purple};
  display: inline-block;
  max-width: 120px;
`;

export const PurpleColor = theme.color.purple;

export default PostNavigationMenu;
